module.exports = "select.form-control.is-invalid {\n  background-image: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/automotriz/simulador/automotriz-simulador.component.scss
// module id = ./src/app/creditos/automotriz/simulador/automotriz-simulador.component.scss
// module chunks = main